import React, { Component } from 'react';
interface Props {
  children: React.ReactNode;
  onNavigate?: (page: string) => void;
}
interface State {
  hasError: boolean;
  error: Error | null;
}
export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null
    };
  }
  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error
    };
  }
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }
  handleReset = () => {
    this.setState({
      hasError: false,
      error: null
    });
    if (this.props.onNavigate) {
      this.props.onNavigate('home');
    }
  };
  render() {
    if (this.state.hasError) {
      return <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4" data-id="element-15778">
          <div className="text-center max-w-md" data-id="element-15779">
            <div className="text-6xl mb-6" data-id="element-15780">⚠️</div>
            <h1 className="text-2xl font-bold text-slate-900 mb-3" data-id="element-15781">
              Что-то пошло не так
            </h1>
            <p className="text-slate-500 mb-6 leading-relaxed" data-id="element-15782">
              Произошла непредвиденная ошибка. Попробуйте обновить страницу или
              вернуться на главную.
            </p>
            {this.state.error && <details className="mb-6 text-left" data-id="element-15783">
                <summary className="text-xs text-slate-400 cursor-pointer hover:text-slate-600 transition-colors" data-id="element-15784">
                  Техническая информация
                </summary>
                <pre className="mt-2 p-3 bg-slate-100 rounded-lg text-xs text-slate-600 overflow-auto max-h-32" data-id="element-15785">
                  {this.state.error.message}
                </pre>
              </details>}
            <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-15786">
              <button onClick={() => window.location.reload()} className="px-6 py-2.5 bg-slate-900 text-white rounded-xl text-sm font-semibold hover:bg-slate-800 transition-colors" data-id="element-15787">
                Обновить страницу
              </button>
              <button onClick={this.handleReset} className="px-6 py-2.5 bg-white text-slate-700 border border-slate-200 rounded-xl text-sm font-semibold hover:bg-slate-50 transition-colors" data-id="element-15788">
                На главную
              </button>
            </div>
          </div>
        </div>;
    }
    return this.props.children;
  }
}